module.exports = __webpack_public_path__ + "img/post1.18dd824a.jpg";